var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowLeftThin = function ArrowLeftThin(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 6 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { id: 'Dark-Breadcrumb-Arrow', d: 'M5.2 14l.8-.7L1.4 7 6 .7 5.2 0 0 7z', className: 'st0' })
    )
  );
};
/*eslint-enable */

export default ArrowLeftThin;
//# sourceMappingURL=ArrowLeftThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowLeftThin.js